<template>
  <div class="pdf">
    <pdf
      v-for="currentPage in pageCount"
      :key="currentPage"
      :src="src"
      :page="currentPage"
      @loaded="loadPdfHandler"
    >
    </pdf>
  </div>
</template>

<script>
import pdf from "vue-pdf";

export default {
  components: {
    pdf,
  },
  data() {
    return {
      currentPage: 1, // pdf文件页码
      pageCount: 15, // pdf文件总页数
      src: "", // pdf文件地址
    };
  },
  created() {
    this.src = pdf.createLoadingTask(this.src);
  },
  method: {
    loadPdfHandler(e) {
      this.currentPage = 1; // 加载的时候先加载第一页
    },
  },
};
</script>
<style lang="scss" scoped>
.pdf {
  width: 100%;
  height: 100%;
}
</style>
